import { createSlice } from "@reduxjs/toolkit";
import { defaultFeedbackToastComponentProps } from "../cubeComponent/constants";

const toastSlice = createSlice({
  name: "toastNotificationContent",
  initialState: {},
  reducers: {
    setToastNotification: (_state, action) =>
      action.payload && action.payload.content ? { ...defaultFeedbackToastComponentProps, ...action.payload } : {},
  },
});

export const { setToastNotification } = toastSlice.actions;
export default toastSlice.reducer;
